import { render, staticRenderFns } from "./LoginLocal.vue?vue&type=template&id=2ab8e9c6&scoped=true"
import script from "./LoginLocal.vue?vue&type=script&lang=js"
export * from "./LoginLocal.vue?vue&type=script&lang=js"
import style0 from "./LoginLocal.vue?vue&type=style&index=0&id=2ab8e9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8e9c6",
  null
  
)

export default component.exports